import React from 'react';
import { motion } from 'framer-motion';
import { costs } from '../../data/content';
export function CostOfInaction() {
  return <section className="py-24 relative bg-pistachio-50 border-y border-line" data-id="element-26" data-mp="2qu6qo3t1djjg">
      <div className="container mx-auto px-4" data-id="element-27" data-mp="2lszja5ut2mdb">
        <div className="text-center mb-16" data-id="element-28" data-mp="2lvvh7u6nlb1r">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-ink flex items-center justify-center gap-3" data-id="element-29" data-mp="2gvh8sb153z37">
            <span aria-hidden="true" data-id="element-30" data-mp="2ctw0z43gqazv">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16" data-id="element-31" data-mp="281m5z9nhqkqq">
          <p className="md:hidden text-center text-sm text-muted mb-4" data-id="element-32" data-mp="233awx150se9k">
            ← Deslizá para ver la tabla completa →
          </p>
          <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-line bg-surface" data-id="element-33" data-mp="1y59bi9k4g2ux">
            <table className="w-full min-w-[620px] text-left border-collapse" data-id="element-34" data-mp="1t3tq2ge17uc0">
              <thead data-id="element-35" data-mp="1p39tbdxdesqe">
                <tr className="border-b border-line bg-pistachio-100/70" data-id="element-36" data-mp="1p4t8t2b7czr4">
                  <th className="p-5 font-semibold text-clay-700 w-1/2" data-id="element-37" data-mp="mcxfi2dpc8du">
                    ❌ Sin Mega Pack
                  </th>
                  <th className="p-5 font-semibold text-pistachio-800 w-1/2" data-id="element-38" data-mp="r5i5esthm1c3">
                    ✅ Con Mega Pack
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line" data-id="element-39" data-mp="hf5pjdwmawca">
                {costs.map(row => <tr key={row.sin} className="hover:bg-pistachio-50/60 transition-colors" data-id="element-40" data-mp="154q99z0lhxmm">
                    <td className="p-5 text-muted text-sm" data-id="element-41" data-mp="1a31koe6jgg6y">{row.sin}</td>
                    <td className="p-5 text-ink text-sm font-medium" data-id="element-42" data-mp="w30fimj8qmlo">{row.real}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto" data-id="element-43" data-mp="3gt925nfvrgeo">
          <p className="text-3xl md:text-5xl font-display font-bold text-pistachio-700 italic mb-8" data-id="element-44" data-mp="1rc40ku0by3te">
            El próximo domingo puede ser diferente.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-45" data-mp="1mdsrilhuzxc8">
            {['Dos horas.', 'Seis módulos listos.', 'Semana resuelta.'].map(item => <span key={item} className="px-4 py-2 rounded-lg bg-surface border border-line text-sm font-semibold text-ink" data-id="element-46" data-mp="1cnzfxkhpvi7z">
                {item}
              </span>)}
          </div>
          <p className="text-muted text-lg" data-id="element-47" data-mp="13om9l0ow39rh">
            Ese es el único domingo que necesitás para cambiar cómo comés el resto del año.
          </p>
        </motion.div>
      </div>
    </section>;
}